module.exports = __webpack_public_path__ + "static/img/solution_case2.762945c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/solution/solution_case2.png
// module id = FWV3
// module chunks = 34